import { useState } from 'react';
import type { DaySummary } from '@calorie/shared';
import { GoalsPanel } from './GoalsPanel.js';
import { haptic } from '../lib/telegram.js';
import { FlameIcon } from './FlameIcon.js';

/** Разряды в четырёхзначных калориях - иначе «1317» читается хуже, чем «1 317». */
const fmt = (v: number) => Math.round(v).toLocaleString('ru-RU');

/**
 * Итог дня одной строкой: калории и БЖУ.
 *
 * Прогресс к норме показывается не здесь, а в панели, которая раскрывается
 * по нажатию: в самой плашке важны только сами числа.
 */
export function DaySummaryBar({ day }: { day: DaySummary }) {
  const [open, setOpen] = useState(false);
  const { consumed, goals } = day;
  const over = consumed.kcal > goals.kcal;

  return (
    <>
      <button
        className="glass summary"
        aria-label={`Съедено ${fmt(consumed.kcal)} из ${fmt(goals.kcal)} ккал`}
        aria-expanded={open}
        onClick={() => {
          haptic();
          setOpen((v) => !v);
        }}
      >
        <div className="summary-row">
          <span className={`sum sum-kcal${over ? ' over' : ''}`}>
            <FlameIcon className="sum-flame" />
            {fmt(consumed.kcal)}
          </span>
          <span className="sum-dot" aria-hidden="true" />
          <span className="sum sum-p">
            <b>Б</b>
            {fmt(consumed.protein)}
          </span>
          <span className="sum-dot" aria-hidden="true" />
          <span className="sum sum-f">
            <b>Ж</b>
            {fmt(consumed.fat)}
          </span>
          <span className="sum-dot" aria-hidden="true" />
          <span className="sum sum-c">
            <b>У</b>
            {fmt(consumed.carbs)}
          </span>
        </div>
      </button>

      {open && (
        <>
          {/* Ловит касание мимо панели, чтобы её можно было закрыть где угодно */}
          <div
            className="goals-scrim"
            onClick={() => setOpen(false)}
            role="presentation"
          />
          <GoalsPanel day={day} />
        </>
      )}
    </>
  );
}
